import {
  ACCOUNT_OVERVIEW_SEARCH_FETCH,
  ACCOUNT_REPORT_SEARCH_FETCH,
  ACCOUNT_GROUPED_CERTIFICATES_FETCH,
  ACCOUNT_EECS_OVERVIEW_SEARCH_FETCH,
  ACCOUNT_EECS_TOTAL_FETCH,
  SET_EECS_GO_ROWS,
} from '../constants/actionTypes/accountActionTypes';
import {
  createAsyncReducer,
  listInitialAsyncState,
  initialAsyncState,
} from '../utils/asyncHelpers';
import { handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initialState = Map({
  listOverview: listInitialAsyncState,
  listReport: listInitialAsyncState,
  groupedCertificates: listInitialAsyncState,
  cancelAvailability: initialAsyncState,
  eecsGoRowsForAction: [],
});

const accountOverviewReducer = handleActions(
  {
    ...createAsyncReducer(ACCOUNT_OVERVIEW_SEARCH_FETCH, 'listOverview'),
    ...createAsyncReducer(ACCOUNT_REPORT_SEARCH_FETCH, 'listReport'),
    ...createAsyncReducer(
      ACCOUNT_EECS_OVERVIEW_SEARCH_FETCH,
      'eecsListOverview'
    ),
    ...createAsyncReducer(ACCOUNT_EECS_TOTAL_FETCH, 'eecsTotal'),
    ...createAsyncReducer(
      ACCOUNT_GROUPED_CERTIFICATES_FETCH,
      'groupedCertificates'
    ),
    [SET_EECS_GO_ROWS]: (state, action) =>
      state.set('eecsGoRowsForAction', action.payload),
  },
  initialState
);

export const getOverviewList = (state) =>
  state.getIn(['accountOverview', 'listOverview']);

export const getEecsListData = (state) =>
  state.getIn(['accountOverview', 'eecsListOverview', 'data']);

export const getEecsTotal = (state) =>
  state.getIn(['accountOverview', 'eecsTotal', 'data']);

export const getOverviewListData = (state) =>
  getOverviewList(state).get('data');

export const getReportList = (state) =>
  state.getIn(['accountOverview', 'listReport']);

export const getReportListData = (state) => getReportList(state).get('data');

export const getGroupedCertificates = (state) =>
  state.getIn(['accountOverview', 'groupedCertificates']);

export const getGroupedCertificatesData = (state) =>
  getGroupedCertificates(state).get('data');

export const getEecsGoRowsForAction = (state) =>
  state.getIn(['accountOverview', 'eecsGoRowsForAction']);

export default accountOverviewReducer;
